export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
          联系我们
        </h2>
        <p className="text-foreground-500 text-sm md:text-base mb-8">
          欢迎投稿、合作或提出宝贵建议
        </p>

        <div className="bg-background-100 rounded-lg p-6 md:p-8 border border-background-200/70 inline-block mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
            <div>
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">投稿邮箱</p>
              <p className="text-sm text-foreground-800 font-medium">contact@blueberrycinema.com</p>
            </div>
            <div>
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-shake-hands-line text-accent-600 text-xl"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">商务合作</p>
              <p className="text-sm text-foreground-800 font-medium">biz@blueberrycinema.com</p>
            </div>
            <div>
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-feedback-line text-secondary-600 text-xl"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">意见反馈</p>
              <p className="text-sm text-foreground-800 font-medium">feedback@blueberrycinema.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}